const Smt = () => {
    return (
        <>
            
        </>
    )
}

export default Smt;